import React from 'react';
import ShowIff from '../ui/ShowIff.js';
import EmployeeSelector from '../employee/selector.js'; // Takes an employee ID
import NumericInput from 'react-numeric-input';
import FieldSelector from '../farm/field/selectorfarm.js';
import InputWrapper from '../forms/InputWrapper.js';
import TaskSelector from './TaskSelector.js'; // Takes a value...
import {callback} from '../../helpers.js';


// Need to CSS this
import './add-row.scss';

const AttendanceAddFormRow = (props) => {

	const changeValue = (field, e) => {
		callback(props.onChange, [field, e]);
	}

	const fieldChange = (e) => {
		if (props.onFarmAndFieldChange === false) {
			changeValue('field', e === null ? 0 : e.FieldID);
			changeValue('farm', e === null ? 0 : e.FarmID);
		} else
			callback(props.onFarmAndFieldChange, [e]);
	}

	const isdefault = props.employee === false;

	return <div className={"add-row" + (isdefault ? " default": " notdefault")}>
		<div>
			<ShowIff iff={props.employee !== false}>
				<InputWrapper label="" info={!isdefault ? false : "The employee this entry refers to."}>
					<EmployeeSelector onChange={changeValue.bind(this, 'employee')} employee={props.employee} />
				</InputWrapper>
			</ShowIff>
			<ShowIff iff={props.employee === false}>
				<em>[Employee]</em>
			</ShowIff>
		</div>
		<div>
			<InputWrapper label="did" info={!isdefault ? false : "The task they performed."}>
				<TaskSelector date={props.date} field={props.field} onChange={changeValue.bind(this, 'task')} task={props.task} />
			</InputWrapper>
		</div>
		<div>
			<InputWrapper label="for" className="hours" info={!isdefault ? false : "The employee time they spent doing it."}>
				<NumericInput className="hours" name="hours" min={0} max={24} value={props.hours} step={0.25} precision={2} onChange={changeValue.bind(this, 'hours')} /> hours
			</InputWrapper>
		</div>
		<div>
			<ShowIff iff={props.field !== false}>
				<InputWrapper label="on" info={!isdefault ? false : "The field they did it on."}>
					<FieldSelector onChange={fieldChange} field={props.field} farm={props.farm} from={props.date} until={props.date} showClear={true} />
				</InputWrapper>
			</ShowIff>
		</div>
	</div>;
}
export default AttendanceAddFormRow;